import React from "react";
import { useParams } from "react-router-dom";
import { List } from "components";
import { getUserFields } from "components/user/config";
import ReviewerCoverageCount from "./components/reviewer-coverage-count";
import { RenderProfile } from "components/render-profile";

export default function RevieweeCoverage() {
  const { quadId } = useParams();

  const fields = [...getUserFields()];

  const columns = [
    {
      id: "reviewee",
      header: "Reviewee",
      accessorKey: "reviewee",
      cell: ({ row }) => <RenderProfile user={row.original} />,
    },

    {
      id: "count",
      header: "Reviewers",
      accessorKey: "id",
      cell: ({ row }) => (
        <ReviewerCoverageCount employeeId={row.original.id} quadId={quadId} />
      ),
    },
  ];

  const filters = {
    user: { status: { _eq: "active" } },
    type: { _eq: "maker" },
  };

  return (
    <div className="flex-1 h-full">
      <List
        title="Reviewee Coverage"
        endPoint="employees"
        filters={filters}
        sortBy="employee_id"
        sortOrder="asc"
        meta={{ fields }}
        columns={columns}
        href={(item) => item.id}
        storageKey={`reviewer-coverage-view-${quadId}`}
      />
    </div>
  );
}
